import * as z from "zod";

// Полная схема с полной валидацией
export const formSchema = z.object({
  journalnumber: z.string().min(1, "Номер журнала обязателен"),
  projectCharacteristics: z.string().min(1, "Заполните характеристики"),
  constructionStartDate: z
    .string()
    .min(1, "Дата начала строительства обязательна"),
  constructionEndDate: z.string().optional(),
  mainJournalStartDate: z.string().min(1, "Дата начала журнала обязательна"),
  mainJournalEndDate: z.string().optional(),
  comment: z.string().optional(),
});

